import {jwtDecode} from 'jwt-decode';
import logger from '../utils/logger';
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch (error) {
    logger.error('Ошибка при декодировании маркера:', error);
    return true;
  }
};

function isAuth(){
    if (localStorage.getItem('Authorization') !== null) { // если токен есть
        let token = localStorage.getItem('Authorization')
        if(!isTokenExpired(token)){ // если время жизни токена не истекло
            return true
        } else {
            localStorage.removeItem('Authorization'); // удаляем токен
return false
        } // если токена умер то возвращаем фолс
    } else {return false} // если токена нет возвращаем фолс
}

export default isAuth;